import { A11yModule } from '@angular/cdk/a11y';
import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AccessibleClickDirective } from '@shared/shared/directives/accessible-click.directive';
import { LanguageService } from '@shared/shared/services/language-service';

@Component({
  selector: 'options-dialog',
  templateUrl: './options-dialog.component.html',
  styleUrls: ['./options-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    MatLegacyDialogModule,
    TranslateModule,
    MatLegacyButtonModule,
    A11yModule,
    MatIconModule,
    AccessibleClickDirective,
  ],
})
export class OptionsDialogComponent {
  public rightToLeftSite: boolean;
  constructor(
    public dialogRef: MatDialogRef<OptionsDialogComponent>,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      body: string;
      okButton: string;
      cancelButton: string;
      isWarning: boolean;
      isCloseIconVisible: boolean;
    }
  ) {
    this.rightToLeftSite = this.languageService.isRtlLanguage();
  }

  public selected(option: boolean) {
    this.dialogRef.close(option);
  }
}
